import DepsService from 'services/dependencies';
import roles from 'app/validators/roles';
import { evalMeta } from 'utils/grid/grid';

const USER_CONTEXT = 'user';
const NA_VALUE = 'n/a';
const ACTIVE = 'ACTIVE';

export const getUsers = (parameters) => {
  const allParameters = {
    ...parameters,
    statusCode: ACTIVE,
    userClass: roles.RETAILER_PRIMARY_ROLE,
  };
  return DepsService.restSrv.list(USER_CONTEXT, DepsService.rest.user.users.url, allParameters).then((result) => {
    const items = (result.content || []).map((user) => {
      const retailerId = _.get(user, 'primaryRetailer.retailerId');
      _.set(user, 'isActive', user.status && user.status.status === ACTIVE);
      _.set(user, 'repeatId', `${retailerId}${user.id}`);
      _.set(user, 'name', `${user.contact.lastName} ${user.contact.firstName}`);
      _.set(user, 'primaryRetailerId', retailerId || NA_VALUE);
      return user;
    });
    return {
      items,
      meta: evalMeta(result),
    };
  });
};



// WEBPACK FOOTER //
// ./src/modules/user/user-service.js